import {
  FileUpdateContextThumbnailModal,
  GroupsEditForm,
  GroupsManageGroupAlbumsModal,
  GroupsManageGroupUsersModal,
  GroupsManageUserGroupsModal
} from '#components';
import {html2text} from '~/utils/sanitizers.js';

export function useGroupsActions() {

  function createEditGroup(group) {
    return new Promise(resolve => {
      useFModal({
        id: 'group-edit',
        clickToClose: false,
        component: GroupsEditForm,
        props: {group},
        eventHandlers: {
          onSuccess(resGroup) {
            this.close();
            resolve(resGroup);
          }
        }
      }).open();
    });
  }

  function deleteGroup(group) {
    return new Promise(resolve => {
      const groupName = html2text(group.name);
      useConfirmModal({
        heading: `Delete Group?`,
        message: `Are you sure you want to delete the group "${groupName}"? Members will lose access to all albums currently shared with it.`,
        confirmMethod: async () => {
          try {
            await useGroupsStore().deleteGroup(group.id);
          } catch (e) {
            useErrorToast().add();
          }
        },
        onConfirm: () => resolve()
      }).open()
    });
  }

  function manageGroupAlbums(group) {
    return new Promise(resolve => {
      useFModal({
        id: 'manage-group-albums',
        clickToClose: false,
        component: GroupsManageGroupAlbumsModal,
        props: {group},
        eventHandlers: {
          onSuccess() {
            resolve();
          }
        }
      }).open();
    });
  }

  function manageGroupUsers(group) {
    return new Promise(resolve => {
      useFModal({
        id: 'manage-group-users',
        clickToClose: false,
        component: GroupsManageGroupUsersModal,
        props: {group},
        eventHandlers: {
          onSuccess() {
            resolve();
          }
        }
      }).open();
    });
  }

  function manageUserGroups({user, userStore = useUsersStore()}) {
    return new Promise(resolve => {
      useFModal({
        id: 'manage-user-groups',
        component: GroupsManageUserGroupsModal,
        props: {user},
        eventHandlers: {
          async saved() {
            await userStore.refreshConnection({userIdOrSlug: user.id});
            resolve();
          }
        }
      }).open();
    });
  }

  function editThumbnail(group) {
    const modal = useFModal({
      id: 'edit-album-thumbnail',
      component: FileUpdateContextThumbnailModal,
      size: 'fullscreen',
      showClose: false,
      props: {
        name: group.name
      },
      eventHandlers: {
        async complete(file) {
          try {
            await useGroupsStore().updateGroup({
              id: group.id,
              forever_file_id: file.id
            });
            modal.close();
          } catch (e) {
            useErrorToast().add();
          }
        }
      }
    });

    modal.open();
  }

  return {
    createEditGroup,
    deleteGroup,
    manageGroupAlbums,
    manageGroupUsers,
    manageUserGroups,
    editThumbnail
  }
}
